import { appUrl } from './config';

const location = window && window.location;
const url = new URL(
  appUrl || (location && `${location.protocol}//${location.host}`),
);

export default url;
